import { configureStore } from '@reduxjs/toolkit'
import shopsyReducer from './shopSlice'

export const store = configureStore({
  reducer: {
    shopsyReducer,
  },
}) 